import { render, staticRenderFns } from "./SectionPrehomeBannerList.vue?vue&type=template&id=4a12d70a"
import script from "./SectionPrehomeBannerList.vue?vue&type=script&lang=js"
export * from "./SectionPrehomeBannerList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports